import { ReactNode } from 'react'

import { useCurrentCompanyContext } from 'src/context/CurrentCompanyContext'

type CompanyFeatureFlag = 'trainingEnabled' | 'voiceAgentEnabled' | 'expirationTrackingEnabled'

const CompanyFeatureGate = ({
  feature,
  children,
}: {
  feature: CompanyFeatureFlag
  children: ReactNode
}) => {
  const currentCompany = useCurrentCompanyContext()

  if (!currentCompany?.[feature]) {
    return null
  }

  return children
}

export default CompanyFeatureGate
